// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer for Export Report.
 * @see #/components/schemas/ExportReport - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface ExportReport {
    /**
     * The Encounter Id.
     * @dataFormat uuid
     */
    encounter_id: string;
    /**
     * The type of the report.
     *
     */
    report_type: string;
    /**
     * The RFID to authenticate the user.
     *
     */
    rfid: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for ExportReport
 */
export namespace ExportReport {
    /**
     * ExportReport Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * The Encounter Id.
         * @dataFormat uuid
         */
        encounterId: string;
        /**
         * The type of the report.
         * @type string (`dataFormat` is missing)
         */
        reportType: string;
        /**
         * The RFID to authenticate the user.
         * @type string (`dataFormat` is missing)
         */
        rfid: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * ExportReport DTO
     * Transforms ExportReport model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend ExportReport model */
        static toModel(obj: ExportReport): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend ExportReport model */
        static toApi(obj: Model): ExportReport {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as ExportReport;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
